import { Badge, BadgeProps } from "antd";
import React, { FC } from "react";

export const MiddleDot: FC<BadgeProps> = ({ ...props }) => (
  <Badge {...props} dot style={{ top: 0, marginLeft: 4, marginRight: -8 }} />
);
